<script setup lang="ts">
const { setLocale, locale } = useI18n()
const { status } = useAuth()
const VALIDATION_ERROR = 422

const current_locale_icon = computed(() => {
    switch (locale.value) {
        case 'en':
            return 'i-emojione-flag-for-united-states'
        case 'tr':
            return 'i-emojione-flag-for-turkey'
        case 'dk':
            return 'i-emojione-flag-for-denmark'
    }
});

let change_locale = async (locale: "en" | "tr" | "dk") => {
    if (status.value == 'unauthenticated') {
        await setLocale(locale)
        return
    }

    let { error } = await useCustomFetch('/api/auth/update-lang', { body: { 'language': locale }, method: 'POST' })
    if (error.value) {
      if (error.value?.statusCode == VALIDATION_ERROR) {
        raiseError('general.validation_error', error.value.data);

      } else {
        raiseGeneralError()
      }
    } else {
        await setLocale(locale)
    }
}

const languages = [
    [{
        label: 'Dansk',
        icon: 'i-emojione-flag-for-denmark',
        click: async () => await change_locale('dk')
    }, {
        label: 'English',
        icon: "i-emojione-flag-for-united-states",
        click: async () => await change_locale('en'),
    }, {
        label: 'Türkçe',
        icon: 'i-emojione-flag-for-turkey',
        click: async () => await change_locale('tr')
    }]
]
</script>

<template>
    <UDropdown :items="languages" :popper="{ placement: 'bottom-start' }">
        <UButton color="white" :icon="current_locale_icon" />
    </UDropdown>
</template>
